<template>
  <div>
    <!-- {{languageMode}} -->
    <!--Edit by ankit-->
    <a
      class="mdc-list-item d-flex justify-content-between align-items-center"
      @click="toggleLanguageSelect()"
      :class="{ 'mdc-list-item__active': getCurrentTab('learn?status=LEARNING')}"
      >
      <!-- :class="{ 'mdc-list-item-active': isElearningSelect }" -->
      <span class="drawer-icon-size material-icons mdc-list-item__graphic">
        <span class="material-icons navi-icons" :class="{ 'mdc-list-item__active__text': getCurrentTab('learn?status=LEARNING')}">menu_book</span>
      </span>
      <p class='N-display' v-if="newContent" data-letters="N" />
      <div class="flex-grow-1">
        {{ group.groupCategory.name }}
      </div>

      <!-- 언어선택 -->
      <i class="material-icons">
        {{ openCategory === "elearning" ? "expand_less" : "expand_more" }}
      </i>
    </a>
    <!-- <transition name="slide"> -->
    <div v-if="openCategory === 'elearning'">
      <div v-for="(contentNav, index) in categoryList" :key="index">
        <router-link
          class="mdc-list-item"
          :to="`/learn?status=LEARNING&category=${contentNav.id}&groupCategoryId=${group.groupCategory.id}`"
          style="color: #212121"
          :class="{ 'mdc-list-item__active__text': getCurrentRoute(`/learn?status=LEARNING&category=${contentNav.id}`)}"
        >
          <i class="material-icons mdc-list-item__graphic"></i>

          <p v-if="newCategory.includes(contentNav.id)" data-letters="N" />
          {{ contentNav.name }}
        </router-link>
      </div>
    </div>
    <!-- </transition> -->
  </div>
</template>

<script>
/**
 * 네비게이션 드로워 언어 목록 컴포넌트(navigation drawer language list Components)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import { mapState, mapMutations } from "vuex";

import mainApi from "@/api/mainApi.js";

export default {
  props: ["openCategory", "group"],
  data() {
    return {
      isElearningSelect: false,
      categoryList: [],
      categoryIdArray: [],
      newContent: false,
      newCategory: [],
      specificIds: process.env.VUE_APP_CONTENTS_IDX
    };
  },
  computed: {
    ...mapState(["languageMode"]),
  },

  mounted() {
    mainApi
      .fetchNew()
      .then((response) => {
        let resultData = response.data.data;
        resultData.forEach((item) => {
          this.newCategory.push(item.id);
        });

        if (localStorage.getItem("brandCode")) {
          mainApi
            .fetchGroupCategory({
              groupCategoryId: this.group.groupCategory.id,
            })
            .then((response) => {
              const categoryResultData = response.data.data[0];
              if (categoryResultData) {
                let list = [];
                list = categoryResultData.parentCategories;
                this.categoryList = list;

                // get all category Ids
                this.categoryIdArray = this.categoryList.map((item) => item.id);

                // match new content array with categories
                this.newContent = this.categoryIdArray.some((item) =>
                  this.newCategory.includes(item)
                );
              }
            });
        }
      })
      .catch((err) => {
        let responseData = err.response.data.meta;
        this.$error({ content: responseData.errMsg }).then(() => {});
      });
  },

  methods: {
    ...mapMutations(["SET_LANGUAGE_MODE"]),
    // 언어 목록 토글(toggle language list)
    toggleLanguageSelect() {
      this.isElearningSelect = !this.isElearningSelect;
      this.handleCategory();
    },
    handleCategory() {
      this.$emit("handleCategory", this.isElearningSelect ? "elearning" : null);
    },
    // 언어 변경(change language)
    changeLanguage(lang) {
      //setUserLanguage(lang.code).then(() => {
      this.$emit("closeDrawer");
      //})
    },
    getCurrentTab(tabName) {
      const fullPath = this.$route.fullPath.toLowerCase();
      return fullPath.indexOf(tabName.toLowerCase()) !== -1 ? true : false;
    },
    getCurrentRoute(item) {
      const isCurrentRoute = this.$route.fullPath.includes(item);
      return isCurrentRoute;
    }
  },
};
</script>
<style scoped>
.mdc-list-item {
  color: #818181 !important;
  text-decoration: none !important;
}
.mdc-list-item-active {
  color: #448aff !important;
}

p.N-display {
    padding-bottom: 2.5px;
}
.mdc-list-item::before {
  background: none !important;
}
.mdc-list-item::after {
  background: none !important;
}
.mdc-list-item__active {
  color: #2d6dcc !important;
}
.mdc-list-item__active__text { 
  color: #2d6dcc !important;
}
</style>
